// Development

// export const SERVER_URL = "https://vebbox.in/chakaraartscraft_backend";
// export const SERVER_PATH = `${SERVER_URL}/controllers/api/`;

export const SERVER_URL =
  "https://chakraartandcraft.com/chakaraartscraft_backend";
export const SERVER_PATH = `${SERVER_URL}/controllers/api/`;

// export const SERVER_URL = "http://localhost/n999_be";
// export const SERVER_PATH = `${SERVER_URL}/controllers/api/`;
